import React from "react";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../general/Loading";
import html2pdf from "html2pdf-fix-jspdf";
import { escalarImagen } from "../../../resources/Helper";
import { generarPdfConTextoNativo } from "../../../utils/pdfHelpers";

function ModalResumenRemision(props) {

    const queryParams = useLocation().search;
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(true);
    const [client, setClient] = useState([]);

    const paciente_id = new URLSearchParams(queryParams).get('id');
    
    const [titulo, setTitulo] = useState('');
    const [contenido, setContenido] = useState('');
    const [fecha, setFecha] = useState('');

    const [nombreProfesional, setNombreProfesional] = useState('');
    const [registroMedico, setRegistroMedico] = useState('');
    const [codigoHabilitacion, setCodigoHabilitacion] = useState('');
    const [firmaimg, setFirmaimg] = useState('');

    const [errorlist, setErrorlist] = useState({});

    let history = useHistory();
    let userdata = [];
    const logoImg = '/smile/dist/img/logo-2.png';
    let img = new Image();
    const [logo,setLogo] = useState();
    const [logoEscalado, setLogoescalado] = useState([]);


    useEffect(() => {

        img.onload = function() {
            setLogoescalado(escalarImagen(img.width, img.height, 18, 18));
            setLogo(img.src);
        }
        
        img.src = props.cliente.logo;

    },[props.cliente]);


    function createMarkup(arg) {
        return {
           __html: arg    };
    }

    const docSlug = () => (props.docPaciente || 'paciente');

    /** HTML para html2pdf: evita título duplicado cuando el contenido ya trae banner (consentimientos). */
    const construirHtmlParaPdf = () => {
        let encabezadoHTML = '';
        if (props.encabezadoPersonalizado) {
            encabezadoHTML = generarEncabezadoHTML(props.encabezadoPersonalizado);
        }

        const incluirTitulo = props.incluirTituloPdf !== false;
        const tituloHtml = incluirTitulo
            ? '<h1 style="text-align: center; margin-bottom: 16px; font-size: 1.25rem; color: #323a45;">' + props.titulo + '</h1>'
            : '';

        const cuerpo =
            encabezadoHTML +
            '<div style="page-break-before: auto; font-family: sans-serif; color: #212529; max-width: 100%;">' +
            tituloHtml +
            props.contenido +
            '</div>';

        return cuerpo;
    };

    const opcionesPdf = () => {
        const base = {
            margin: 10,
            filename: props.tipoArchivo + '-' + docSlug() + '.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: {
                scale: 2,
                useCORS: true,
                allowTaint: true,
                letterRendering: true,
            },
            jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' },
        };

        if (props.pdfAltoContraste || props.tipoArchivo === 'consentimiento-informado') {
            return {
                ...base,
                pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
                html2canvas: {
                    ...base.html2canvas,
                    scrollY: 0,
                },
            };
        }

        return base;
    };

    const imprimirContenido = async () => {
        if (props.pdfNativoConfig) {
            try {
                const pdf = await generarPdfConTextoNativo(props.pdfNativoConfig);
                const name = props.pdfNativoConfig.filename || props.tipoArchivo + '-' + docSlug() + '.pdf';
                pdf.save(name);
            } catch (err) {
                console.error('PDF nativo (descarga):', err);
                alert('No se pudo generar el PDF. Intente de nuevo.');
            }
            return;
        }
        const contenidoImpresion = construirHtmlParaPdf();
        html2pdf(contenidoImpresion, opcionesPdf());
    };

    const imprimirPdf = async () => {
        if (props.pdfNativoConfig) {
            try {
                const pdf = await generarPdfConTextoNativo(props.pdfNativoConfig);
                const blob = pdf.output('blob');
                const url = URL.createObjectURL(blob);
                const w = window.open(url, '_blank');
                if (w) {
                    w.onload = function () {
                        setTimeout(() => {
                            try {
                                w.print();
                            } catch (e) {
                                console.warn(e);
                            }
                        }, 400);
                    };
                }
            } catch (err) {
                console.error('PDF nativo (imprimir):', err);
                alert('No se pudo generar el PDF para imprimir.');
            }
            return;
        }

        const contenidoImpresion = construirHtmlParaPdf();
        const opt = opcionesPdf();

        html2pdf()
            .from(contenidoImpresion)
            .set(opt)
            .toPdf()
            .get('pdf')
            .then(function (pdf) {
                window.open(pdf.output('bloburl'), '_blank');
            })
            .catch(function (err) {
                console.error('html2pdf:', err);
            });
    };

    // 🆕 Función para generar encabezado personalizado HTML
    const generarEncabezadoHTML = (encabezado) => {
        if (!encabezado) {
            return '';
        }

        const limpiarHTML = (html) => {
            if (!html) return '';
            return html
                .replace(/<p>/gi, '<div style="margin: 0; padding: 0; line-height: 1.1;">')
                .replace(/<\/p>/gi, '</div>')
                .replace(/<br\s*\/?>/gi, '<br style="line-height: 1.1;" />');
        };

        return `
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 10px; background-color: #ffffff;">
                <tr>
                    <td style="width: 30%; padding: 2px; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezado.izquierda)}
                    </td>
                    
                    <td style="width: 40%; padding: 2px; text-align: center; font-size: 11px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezado.centro)}
                    </td>
                    
                    <td style="width: 30%; padding: 2px; text-align: right; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezado.derecha)}
                    </td>
                </tr>
            </table>
        `;
    };


    if (loggedIn) {

        /*const seccionProfesional = <div className="card">
                                        <div id="profesional-atiende">
                                            <div className="card-body" style={{padding: '0.7rem'}}>
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="nombreProfesional">Remitido por:</label>
                                                            <br></br>
                                                            {props.profesional}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="nombreProfesional">Registro médico:</label>
                                                            <br></br>
                                                            {props.registro}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="clasificacion_riesgo">Código de habilitación:</label>
                                                            <br></br>
                                                            {props.codigo}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group" style={{marginBottom: '0.4rem'}}>
                                                            <label htmlFor="nombreProfesional">Firma:</label>
                                                            <br></br>
                                                            <img src={props.firma} className="firma-profesional-hc" />
                                                        </div>
                                                    </div>  
                                                </div>
                                            </div>
                                        </div>
                                    </div>;*/

        

        return (
                
                <div className="modal fade show" id={props.idModal} style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">

                        <div className="modal-header">
                            <h4 className="modal-title text-secondary" style={{ fontSize: '1.1rem' }}>{props.titulo}</h4>
                            <button type="button" className="close" onClick={props.onClose}>&times;</button>
                        </div>

                        <div className="modal-body" style={{paddingTop: '0.5rem'}}>

                            <section className="content">
                                <div className="container-fluid">

                                    <div className="row">
                                        <div className="col-md-12">

                                            <div id="historiageneral">
                                                <div className="row">
                                                    <div className="col-md-12 resumen-historico" dangerouslySetInnerHTML={createMarkup(props.contenido)}>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            
                                                
                                            <div className="row" style={{ marginTop: '1.5rem', paddingTop: '0.75rem', borderTop: '1px solid #e9ecef' }}>
                                                <div className="col-md-12 d-flex flex-wrap align-items-center">
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-dark mr-2 mb-1"
                                                        onClick={() => (props.imprimirFuncion ? props.imprimirFuncion() : imprimirPdf())}
                                                    >
                                                        <i className="fas fa-print mr-1"></i> Imprimir
                                                    </button>
                                                    <button type="button" className="btn btn-sm btn-dark mr-2 mb-1" onClick={() => imprimirContenido()}>
                                                        <i className="fas fa-download mr-1"></i> Descargar PDF
                                                    </button>
                                                    {typeof props.onEnviarEmail === 'function' && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-outline-info mr-2 mb-1"
                                                            onClick={() => props.onEnviarEmail()}
                                                            disabled={props.enviandoEmail}
                                                        >
                                                            {props.enviandoEmail ? (
                                                                <>
                                                                    <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                                                                    Enviando...
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <i className="fas fa-envelope mr-1"></i> Email
                                                                </>
                                                            )}
                                                        </button>
                                                    )}
                                                    <button type="button" onClick={props.onClose} className="btn btn-sm btn-secondary mb-1">
                                                        Cerrar&nbsp;
                                                        {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                                    </button>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default ModalResumenRemision;